import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Component, OnInit, ViewChild, OnChanges } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { QuillEditorComponent } from 'ngx-quill';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FileHolder } from 'angular2-image-upload';
import { GeneralSettingService } from './general-setting.service';

@Component({
  selector: 'app-general-setting',
  templateUrl: './general-setting.component.html',
  styleUrls: ['./general-setting.component.css']
})
export class GeneralSettingComponent implements OnInit {
  generalSettingForm: DVFormGroup;
  isAddState = true;
  stateName: string;
  file: string;
  @ViewChild('editor', {
    static: true
  })
  editor: QuillEditorComponent;
  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'display',
    allowSearchFilter: false,
  };
  experiences: any[];

  constructor(
    private generalSettingApi: GeneralSettingService,
    private notifier: SnotifyService,
    private router: Router,
    public route: ActivatedRoute
  ) {
    // this.generalSettingApi.getAllGeneralSetting().subscribe(Response => {
    //   // console.log(Response)
    // });
    this.generalSettingForm = new DVFormGroup({
      homeTitle: new DVFormControl(null, {
        'Home Title  is required': Validators.required
      }),
      homeDescription: new DVFormControl(),
      homeImage: new DVFormControl(),
      homeLocalImage: new DVFormControl(),
      homePackageImage: new DVFormControl(),
      homeMetaTitle: new DVFormControl(),
      homeMetaDescription: new DVFormControl(),
      homeMetaKeywords: new DVFormControl(),

      localExpTitle: new DVFormControl(null, {
        'Local Experience Title  is required': Validators.required
      }),
      localExpDescription: new DVFormControl(),
      localExpImage: new DVFormControl(),
      localExpMetaTitle: new DVFormControl(),
      localExpMetaDescription: new DVFormControl(),
      localExpMetaKeywords: new DVFormControl(),

      packageTitle: new DVFormControl(null, {
        'package Title  is required': Validators.required
      }),
      packageDescription: new DVFormControl(),
      packageImage: new DVFormControl(),
      packageMetaTitle: new DVFormControl(),
      packageMetaDescription: new DVFormControl(),
      packageMetaKeywords: new DVFormControl(),
    });
  }

  ngOnInit() {

    // if (this.route.snapshot.params[`id`]) {
      // this.isAddState = false;
      this.generalSettingApi
        .getGeneralSettingByID(1)
        .subscribe(Response => {
          console.log('sssssssssssssssssss',  Response[`data`]);
          this.generalSettingForm.controls[`homeTitle`].setValue(
            Response[`data`].generalSetting.homeTitle
          );
          this.generalSettingForm.controls[`homeDescription`].setValue(
            Response[`data`].generalSetting.homeDescription
          );
          this.generalSettingForm.controls[`homeMetaTitle`].setValue(
            Response[`data`].generalSetting.homeMetaTitle
          );
          this.generalSettingForm.controls[`homeMetaDescription`].setValue(
            Response[`data`].generalSetting.homeMetaDescription
          );
          this.generalSettingForm.controls[`homeMetaKeywords`].setValue(
            Response[`data`].generalSetting.homeMetaKeywords
          );
          this.generalSettingForm.controls[`homeImage`].setValue(
            Response[`data`].generalSetting.homeImage
          );
          this.generalSettingForm.controls[`homeLocalImage`].setValue(
            Response[`data`].generalSetting.homeLocalImage
          );
          this.generalSettingForm.controls[`homePackageImage`].setValue(
            Response[`data`].generalSetting.homePackageImage
          );
          // this.generalSettingForm.controls.homeImage.setValue(
          //   Response.data.generalSetting.homeImage
          // );

          this.generalSettingForm.controls[`localExpTitle`].setValue(
            Response[`data`].generalSetting.localExpTitle
          );
          this.generalSettingForm.controls[`localExpDescription`].setValue(
            Response[`data`].generalSetting.localExpDescription
          );
          this.generalSettingForm.controls[`localExpMetaTitle`].setValue(
            Response[`data`].generalSetting.localExpMetaTitle
          );
          this.generalSettingForm.controls[`localExpMetaDescription`].setValue(
            Response[`data`].generalSetting.localExpMetaDescription
          );
          this.generalSettingForm.controls[`localExpMetaKeywords`].setValue(
            Response[`data`].generalSetting.localExpMetaKeywords
          );
          this.generalSettingForm.controls.localExpImage.setValue(
            Response.data.generalSetting.localExpImage
          );

          this.generalSettingForm.controls[`packageTitle`].setValue(
            Response[`data`].generalSetting.packageTitle
          );
          this.generalSettingForm.controls[`packageDescription`].setValue(
            Response[`data`].generalSetting.packageDescription
          );
          this.generalSettingForm.controls[`packageMetaTitle`].setValue(
            Response[`data`].generalSetting.packageMetaTitle
          );
          this.generalSettingForm.controls[`packageMetaDescription`].setValue(
            Response[`data`].generalSetting.packageMetaDescription
          );
          this.generalSettingForm.controls[`packageMetaKeywords`].setValue(
            Response[`data`].generalSetting.packageMetaKeywords
          );
          this.generalSettingForm.controls.packageImage.setValue(
            Response.data.generalSetting.packageImage
          );
          // this.generalSettingForm.controls.body.setValue(Response.data.generalSetting.body);

        },
        error => {
          if (error.error.userMessage == "general Setting not found") {
            console.log('Not Found');
            const formValue = this.getCleanValue();
            console.log('>>>>>>>>>>>>>', formValue);
            // formValue.homeTitle = 'Test';
            this.generalSettingApi
            .createGeneralSettig(formValue)
            .subscribe(
              Response => {
                // console.log(Response)
                this.notifier.success('General Setting Created Successfully');
                this.generalSettingForm.reset();
                this.router.navigateByUrl('/settings/general-setting');
              },
              error => {
                this.notifier.error(error.error.userMessage);
              }
            );
          }
        }
        );
    // this.generalSettingForm.controls.body.valueChanges
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe(data => {
    //     // tslint:disable-next-line:no-console
    //     // console.log('native fromControl value changes with debounce', data)
    //   });

    // this.editor.onContentChanged
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe(data => {
    //     // tslint:disable-next-line:no-console
    //     // console.log('view child + directly subscription', data)
    //   });
  }

  // fileUploaded(event) {
  //   // console.log(event)
  //   this.generalSettingForm.controls.coverPhoto.reset();

  //   this.generalSettingForm.controls.coverPhoto.setValue(event[`name`]);
  // }

  // SubmitForm() {
  //   if (this.generalSettingForm.valid) {
  //     const formValue = this.getCleanValue();
  //     this.generalSettingApi.addArticle(formValue).subscribe(
  //       Response => {
  //         this.notifier.success('Article Added Successfully');
  //         this.generalSettingForm.reset();
  //         this.router.navigateByUrl('/settings/blogs/list');
  //       },
  //       error => {
  //         this.notifier.error(error.error.userMessage);
  //       }
  //     );
  //   } else {
  //     this.generalSettingForm.forceShowErrors();
  //   }
  // }

  EditForm() {
    if (this.generalSettingForm.valid) {
      const formValue = this.getCleanValue();
      console.log('Values', formValue);
      this.generalSettingApi
        .editGeneralSettig(formValue, 1)
        .subscribe(
          Response => {
            // console.log(Response)
            this.notifier.success('General Setting Edited Successfully');
            // this.generalSettingForm.reset();
            this.router.navigateByUrl('/settings/general-setting');
          },
          error => {
            this.notifier.error(error.error.userMessage);
          }
        );
    } else {
      this.generalSettingForm.forceShowErrors();
    }
  }

  getCleanValue() {
    return {
      ...this.generalSettingForm.value,
    };
  }

  cancel() {
    this.isAddState = true;
    this.generalSettingForm.reset();
    this.router.navigateByUrl('/settings/general-setting');
  }
  // openDialog() {
  //   document.getElementById('fileButton').click();
  // }
  homeImageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addHomeImage(imageBody);
    }
  }
  private addHomeImage(src) {
    const control = <DVFormControl> this.generalSettingForm.controls[`homeImage`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  homeLocalImageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addHomeLocalImage(imageBody);
    }
  }
  private addHomeLocalImage(src) {
    const control = <DVFormControl> this.generalSettingForm.controls[`homeLocalImage`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  homePackageImageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addHomePackageImage(imageBody);
    }
  }
  private addHomePackageImage(src) {
    const control = <DVFormControl> this.generalSettingForm.controls[`homePackageImage`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  localExpImageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addLocalExpImage(imageBody);
    }
  }
  private addLocalExpImage(src) {
    const control = <DVFormControl> this.generalSettingForm.controls[`localExpImage`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  packageImageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addPackageImage(imageBody);
    }
  }
  private addPackageImage(src) {
    const control = <DVFormControl> this.generalSettingForm.controls[`packageImage`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  imageRemoved(holder: FileHolder) {
  }
}
